var UploadResumesController = /** @class */ (function () {
    /*@ngInject*/
    function UploadResumesController($scope, $rootScope, $timeout, $uibModal, $filter, modalService, alertsAndNotificationsService, resumeService, jobService, MESSAGECONSTANTS, dateTimeUtilityService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.modalService = modalService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.resumeService = resumeService;
        this.jobService = jobService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.dateTimeUtilityService = dateTimeUtilityService;
        Dropzone.autoDiscover = false; // disable dropdown instantiation done in the plugin
    }
    UploadResumesController.prototype.$onInit = function () {
        var _this = this;
        this.initVariables();
        // if(this.controlObject) {
        //     this.controlObject = {
        //         cancel: this.cancelUploadResumes
        //     };
        // }
        this.$scope.$on('cancelUploadResume', function (event, arg) {
            // this.cancelUploadResumes();
        });
        if (this.candidateId !== "") {
            this.isSingleCandidateUpload = true;
        }
        //initialize the variables
        if (!_.isNull(this.jobId) && this.jobId != '') {
            this.jobContextExistsFlag = true;
            this.createJobMatchesObject = {
                companyId: this.$rootScope.userDetails.company.companyId,
                requisitionId: this.jobId,
                candidateIds: [],
                manuallyMatchedFromUI: true,
                transactionId: null,
                isAssociateCandidate: false,
                overrideNoteDetails: []
            };
        }
        this.resumeList = [];
        // get the source types
        this.getAllSourceTypes(function () {
            if (!_.isNull(_this.jobId) && _this.jobId != '') {
                _this.getLastAddedCandidateSourceTypeId();
            }
        });
        // wait for changes to take effect and then create wizard
        this.$timeout(function () {
            //initialize the drop zone configuration
            _this.resumeUploadDropzone = _this.createResumeUploadDropzone();
        }, 300);
        this._initializeUploadDatePicker();
    };
    UploadResumesController.prototype.initVariables = function () {
        this.defaultJobSourceTypeId;
        this.sourceTypeList = [];
        this.resumeList = [];
        this.sourceType = null;
        this.sourceTypeId = null;
        this.otherSourceTypeNotes = null;
        this.referrerName = null;
        this.referrerEmail = null;
        this.uploadResumesResponse = null;
        this.totalUploads = null;
        this.candidatesList = [];
        this.candidatesToAssociateList = [];
        this.candidateCount = null;
        this.createJobMatchesObject = null;
        this.addedFilesInDropzone = [];
        this.maxResumesToUpload = 40;
        this.uploadDate = null;
        this.displayUploadDate = null;
        // flags
        this.isSingleCandidateUpload = false;
        this.disableUploadButtonFlag = true;
        this.fileExistsFlag = false;
        this.disableCancelButtonFlag = false;
        this.fileUploadInProgressFlag = false;
        this.disableSourceTypesFlag = false;
        this.resumeScoringDoneFlag = false;
        this.scoringCandidatesFlag = false;
        this.jobContextExistsFlag = false;
        this.isUploadResumeWarningModalOpen = false;
    };
    UploadResumesController.prototype.getLastAddedCandidateSourceTypeId = function () {
        var _this = this;
        this.jobService.getLastAddedCandidateSourceTypeId(this.jobId, function (data) {
            _this.defaultJobSourceTypeId = data.lastAddedCandidateSourceTypeId;
            _this._setDefaultSourceType();
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    /**
     * creates the resume upload drop zone.
     */
    UploadResumesController.prototype.createResumeUploadDropzone = function () {
        var _this = this;
        var dropZoneSettings = this._getDropZoneSettings();
        var resumeUploadDropzone = new Dropzone("form#resumeUploadDropzone", dropZoneSettings);
        // add event handlers for the drop zone
        resumeUploadDropzone.on('addedfile', function (file, response) {
            _this.fileExistsFlag = true;
            _this.updateActionButtons();
            $('.dz-progress').css({ top: '70%' });
            _this.addedFilesInDropzone.push(file);
            if (!_this.isUploadResumeWarningModalOpen) {
                if (_this.addedFilesInDropzone.length > _this.maxResumesToUpload) {
                    _this.isUploadResumeWarningModalOpen = true;
                    var title = 'Max Limit Exceeded';
                    var message = "There is a maximum limit of <b>" + _this.maxResumesToUpload + "</b> resumes that can be uploaded at once. \n                    <br>You have currently exceeded this limit.\n                    <br>We will reduce the number of files currently being uploaded to " + _this.maxResumesToUpload + ".\n                    <br>The last file in this list is <b>" + _this.addedFilesInDropzone[_this.maxResumesToUpload - 1]["name"] + "</b>";
                    _this.alertsAndNotificationsService.showAlertWithCallBack(title, message, 'warning', function () {
                        _this.isUploadResumeWarningModalOpen = false;
                        _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                        _this.$timeout(function () {
                            $(".modal").addClass("four-dot-five-modal-large");
                        }, 200);
                    });
                }
            }
        });
        resumeUploadDropzone.on('maxfilesexceeded', function (file, response) {
            resumeUploadDropzone.removeFile(file);
        });
        resumeUploadDropzone.on('removedfile', function (file, response) {
            _this.addedFilesInDropzone = _this.addedFilesInDropzone.filter(function (resume) { return resume.upload.uuid !== file.upload.uuid; });
            if (resumeUploadDropzone.files.length === 0) {
                _this.disableUploadButtonFlag = true;
            }
            //do nothing as the resumes are processed async and it cannot be undone
        });
        resumeUploadDropzone.on('sendingmultiple', function (file, xhr, formData) {
            // disable the upload button to avoid multiple clicks
            _this.disableUploadButtonFlag = true;
            // disable changing of source information
            _this.disableSourceTypesFlag = true;
            // indicate that file upload is in progress
            _this.fileUploadInProgressFlag = true;
            var resumeUpload = {};
            resumeUpload.companyId = _this.$rootScope.userDetails.company.companyId;
            resumeUpload.userId = _this.$rootScope.userDetails.id;
            resumeUpload.resumeSourceTypeId = _this.sourceTypeId;
            resumeUpload.buIdList = [];
            // formData.append('resumeUpload', JSON.stringify(resumeUpload));
            formData.append("companyId", resumeUpload.companyId);
            formData.append("resumeSourceTypeId", resumeUpload.resumeSourceTypeId);
            formData.append("userId", resumeUpload.userId);
            formData.append("buIdList", resumeUpload.buIdList);
            if (_this.sourceType.sourceType == 'Other') {
                formData.append("otherSourceTypeNotes", _this.otherSourceTypeNotes);
            }
            else {
                formData.append("otherSourceTypeNotes", null);
            }
            if (_this.sourceType.sourceType == 'Referral') {
                formData.append("referrerName", _this.referrerName);
                formData.append("referrerEmail", _this.referrerEmail);
            }
            else {
                formData.append("referrerName", null);
                formData.append("referrerEmail", null);
            }
            if (!_.isNull(_this.jobId)) {
                formData.append("jobId", _this.jobId);
            }
            if (_this.uploadDate) {
                formData.append("uploadDateAndTime", _this.uploadDate);
            }
        });
        resumeUploadDropzone.on('successmultiple', function (fileArray, response) {
            // remove file upload in progress flag
            _this.fileUploadInProgressFlag = false;
            _this.disableUploadButtonFlag = true;
            _this.alertsAndNotificationsService.showBannerMessage(response.message, 'success');
            if (_this.candidateProcessedCallback) {
                _this.candidateProcessedCallback();
            }
            else if (_this.completeCallback) {
                _this.completeCallback();
            }
            // disable adding of further files
            $(".dz-hidden-input").prop("disabled", true);
            $('.dz-remove').hide();
        });
        resumeUploadDropzone.on("error", function (file, error) {
            var elements = document.querySelectorAll(".dz-file-preview");
            angular.forEach(elements, function (element, index) {
                var filename = element.querySelectorAll(".dz-filename span")[0].textContent;
                var errorMessage = element.querySelectorAll(".dz-error-message span")[0];
                if (filename === file.name) {
                    errorMessage.textContent = error.message == undefined ? error : error.message;
                }
            });
            _this.disableNextButtonFlag = false;
        });
        return resumeUploadDropzone;
    };
    UploadResumesController.prototype._getDropZoneSettings = function () {
        var dropZoneSettings = {};
        var maxFilesToUpload = this.maxResumesToUpload;
        if (this.isSingleCandidateUpload) {
            maxFilesToUpload = 1;
        }
        dropZoneSettings = {
            url: this.resumeService.getUploadUrl() + '/async',
            paramName: function () {
                return "file";
            },
            acceptedFiles: ".pdf,.xlsx,.docx,.doc",
            maxFiles: maxFilesToUpload,
            maxFilesize: 10,
            maxThumbnailFilesize: 10,
            timeout: 300000,
            addRemoveLinks: true,
            autoProcessQueue: false,
            uploadMultiple: true,
            parallelUploads: 100
        };
        if (this.jobContextExistsFlag) {
            dropZoneSettings.url = dropZoneSettings.url + "?jobId=" + this.jobId;
        }
        // else {
        //     dropZoneSettings = {
        //         url: this.resumeService.getUploadUrl(),
        //         paramName: () =>  {
        //             return "file";
        //         },
        //         acceptedFiles: ".pdf,.xlsx,.docx,.doc",
        //         maxFiles: 1,
        //         maxFilesize: 10,
        //         maxThumbnailFilesize: 10,
        //         timeout: 300000,
        //         addRemoveLinks: true,
        //         autoProcessQueue: false
        //     }
        // }
        return dropZoneSettings;
    };
    UploadResumesController.prototype.cancelUploadResumes = function () {
        var _this = this;
        var message = "Are you sure you want to cancel ?";
        var showPopUp = true;
        var createCandidatesFlag = false;
        if (this.resumeScoringDoneFlag) {
            // do nothing.
        }
        else {
            // scoring was not done
            if (this.resumeList.length) {
                // resumes were uploaded
                message = "No job matches will be created for the uploaded candidate(s).<br>Do you still want to continue?";
                createCandidatesFlag = true;
            }
            else if (this.resumeUploadDropzone.files.length > 0) {
                // resumes not uploaded, exist in the dropzone
                message = "Are you sure you want to cancel ?<br>Un-uploaded files exist in the upload area.";
            }
            else {
                // no uploaded resumes exist. no need to show confirmation popup.
                showPopUp = false;
            }
        }
        if (showPopUp) {
            bootbox.confirm({
                closeButton: false,
                title: "<div class='alert alert-warning' style='margin-bottom: 0px;'><i class='fas fa-exclamation-triangle fa-fw fa-lg'></i><strong>Confirm</strong></div>",
                message: message,
                className: "zIndex1060",
                backdrop: true,
                onEscape: false,
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-info'
                    },
                    cancel: {
                        label: 'Cancel',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    var message = "<p class='text-center'>Creating candidate(s) for uploaded resume(s) <i class='fa fa-spinner fa-spin'></i><br>Please go to Candidates screen to view the candidate(s).</p>";
                    if (result) {
                        if (createCandidatesFlag) {
                            var createUploadedCandidatesDialog_1 = bootbox.dialog({
                                message: message,
                                closeButton: false
                            });
                            // scoring was not done and but resumes were uploaded.
                            // make service call to create candidates
                            _this.resumeService.runResumesWithoutScoring(_this.uploadResumesResponse, _this.jobId, function (data) {
                                createUploadedCandidatesDialog_1.modal('hide');
                                _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                                // candidates added successfully without creating job matches
                                if (_this.cancelCallback) {
                                    _this.cancelCallback();
                                }
                            }, function (error) {
                                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                            });
                        }
                        else {
                            if (_this.cancelCallback) {
                                _this.cancelCallback();
                            }
                        }
                    }
                    else {
                        _this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
                    }
                }
            });
        }
        else {
            if (this.cancelCallback) {
                this.cancelCallback();
            }
        }
    };
    /**
     * update the action buttons
     */
    UploadResumesController.prototype.updateActionButtons = function () {
        var _this = this;
        // if resumes exist and scoring is completed, then the functions on this tab are disabled.
        if (this.resumeList.length > 0) {
            this.disableSourceTypesFlag = true;
            this.resumeUploadDropzone.clickable = false;
            this.disableUploadButtonFlag = true;
        }
        else {
            // in else because no resumes have been uploaded yet
            if (this.fileExistsFlag) {
                // if files exist in drop zone
                if (!_.isNull(this.sourceTypeId)) {
                    // and source type is chosen
                    this.disableUploadButtonFlag = false;
                    // this.disableSourceTypesFlag = true;
                }
                else {
                    // and source type is not chosen
                    this.disableUploadButtonFlag = true;
                    // this.disableSourceTypesFlag = false;
                }
            }
            else {
                // files do not exist in drop zone
                this.disableUploadButtonFlag = true;
                this.disableSourceTypesFlag = false;
            }
        }
        this.$timeout(function () {
            _this.$scope.$apply();
        }, 200);
    };
    UploadResumesController.prototype.getAllSourceTypes = function (successCallback) {
        var _this = this;
        this.resumeService.getAllSourceTypes(function (data) {
            _this.sourceTypeList = data;
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (_this.$rootScope.isOnline) {
                _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    };
    UploadResumesController.prototype._setDefaultSourceType = function () {
        var _this = this;
        if (this.defaultJobSourceTypeId !== undefined && this.defaultJobSourceTypeId !== "" && !_.isNull(this.defaultJobSourceTypeId)) {
            var index = this.sourceTypeList.findIndex(function (sourceType) {
                return sourceType.id == _this.defaultJobSourceTypeId;
            });
            if (index !== -1) {
                this.sourceType = this.sourceTypeList[index];
                this.sourceTypeId = this.sourceType.id;
            }
        }
    };
    UploadResumesController.prototype.sourceTypeChanged = function () {
        if (angular.isDefined(this.sourceType) && angular.isDefined(this.sourceType.id)) {
            this.sourceTypeId = this.sourceType.id;
            this.updateActionButtons();
        }
        else {
            this.sourceTypeId = null;
        }
    };
    UploadResumesController.prototype.uploadResumes = function () {
        this.uploadResumesForm.$submitted = true;
        if (!this.uploadResumesForm.$invalid) {
            this.resumeUploadDropzone.processQueue();
        }
    };
    UploadResumesController.prototype._initializeUploadDatePicker = function () {
        var _this = this;
        var today = new Date();
        var todayStr = today.toDateString(); // For comparison
        $('#displayUploadDate').datepicker({
            format: "M d, yyyy",
            endDate: today,
            weekStart: 1,
            autoclose: true
        });
        // Set initial date
        $("#displayUploadDate").datepicker("setDate", today);
        // 1. UI - show in M d, yyyy format
        this.displayUploadDate = this.$filter('fourdotfiveDateFormat')(today);
        $("#displayUploadDate").datepicker("update", this.displayUploadDate);
        // 2. Backend - store ISO timestamp
        this.uploadDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(today);
        $('#displayUploadDate').datepicker().on('changeDate', function (e) {
            var selectedDate = new Date(e.date);
            var selectedStr = selectedDate.toDateString();
            _this.displayUploadDate = _this.$filter('fourdotfiveDateFormat')(selectedDate); // Update UI display
            if (selectedStr === todayStr) {
                // Set uploadDate with current time
                _this.uploadDate = _this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date());
            }
            else {
                // Set time to 11:59:59 PM for earlier dates
                selectedDate.setHours(23, 59, 59, 999);
                _this.uploadDate = _this.dateTimeUtilityService.getDateTimeInAPIFormat(selectedDate);
            }
        });
    };
    UploadResumesController.prototype.receiveFormalizedComment = function (event) {
        this.otherSourceTypeNotes = event;
    };
    UploadResumesController.prototype.onVoiceTranscript = function (transcript) {
        if (this.otherSourceTypeNotes) {
            this.otherSourceTypeNotes += ' ' + transcript;
        }
        else {
            this.otherSourceTypeNotes = transcript;
        }
    };
    return UploadResumesController;
}());
UploadResumesController.$inject = ['$scope', '$rootScope', '$timeout', '$uibModal', '$filter', 'modalService', 'alertsAndNotificationsService', 'resumeService', 'jobService', 'MESSAGECONSTANTS', 'dateTimeUtilityService'];
// import * as TEMPLATE from './upload-resumes.html';
import * as TEMPLATE from 'raw-loader!./upload-resumes.html';
export var UploadResumesComponent = {
    selector: 'uploadResumes',
    component: {
        bindings: {
            jobId: '@',
            candidateId: '@',
            cancelCallback: '&',
            candidateProcessedCallback: '&',
            completeCallback: '&',
            controlObject: '=',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: UploadResumesController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/addCandidates/addCandidates/uploadResumes/upload-resumes.html'
    }
};
//# sourceMappingURL=upload-resumes.component.js.map